<template>
	<v-card
		outlined
	>
		<v-card-title
			class="text_primary"
		>
			{{ page_title }}

			<v-spacer></v-spacer>

			<v-btn
				color="#5087e6"
				@click="exportReport"
				class="white--text"
			>
				匯出報表
			</v-btn>
		</v-card-title>

		<v-divider></v-divider>
		<v-row class="mt-1 mb-1 pr-3">
			<!-- <v-col
				cols="12"
				lg="8"
				md="12"
				xs="12"
			>
                <v-card-text
                    class="d-flex align-center justify-end pl-4 ml-0 pt-0 pr-0 pb-0"
                >
                    <v-text-field
                    dense
                    outlined
                    class="pt-0"
                    v-model="search"
                    label="輸入名稱搜索"
                    single-line
                    hide-details
                    :color="this.$vuetify.theme.themes['dark']['primary']"
                    @keypress.enter="searchKeyword(search)"
                    ></v-text-field>
                    <v-btn 
                        @click="searchKeyword(search)"
                        class="ml-3 btn_action btn_action_bg_linear"
                    >
                        <v-icon>
                            mdi-magnify
                        </v-icon>
                    </v-btn>
                </v-card-text>

			</v-col> -->
			<v-col
				cols="12"
				lg="12"
				md="12"
				xs="12"
			>  
				<v-card-text
					class="d-flex align-center justify-end pa-0"
				>
					<p class="mb-0 pb-0 mr-3">顯示</p>
					<v-select
						style="max-width:7em;"
						outlined
						return-object
						@change="chagePerPage(selected_per_page)"
						v-model="selected_per_page"
						:items="per_page_items"
						item-value="value"
						item-text="name"
						hide-details
						dense
					>
					</v-select>
				</v-card-text>
			</v-col>
		</v-row>
		<v-divider></v-divider>

		<v-data-table
			hide-default-footer
			:headers="headers"
			:items="datas"
			:items-per-page="selected_per_page.value"
		>

			<template v-slot:[`item.ict_start_at`] = "{item}">
				{{$utils.displayISOString(item.ict_start_at)}}
			</template>

			<template v-slot:[`item.ict_end_at`] = "{item}">
				{{$utils.displayISOString(item.ict_end_at)}}
			</template>

		  <template v-slot:[`item.fbtrace_id`] = "{item}">
			<v-icon 
				v-if="item.fbtrace_id"
				color="success"
			>
				mdi-check
			</v-icon>
			<v-icon v-else
				color="warning"
			>
				mdi-close
			</v-icon>
		  </template>

          <template v-slot:[`item.actions`] = "{item}">

            <v-btn
              class="text_default btn_default btn_default_bg_linear"
              outlined
              @click="viewData(item)"
            >
              詳細資料
            </v-btn> 

            <!-- <v-btn
              class="btn_action btn_action_bg_linear mr-3"
              outlined
              @click="edit(item)"
            >
              編輯設定
            </v-btn> 

            <v-btn
			  
              class="btn-danger white--text"
              outlined
              @click="del(item)"
            >
              刪除
            </v-btn>        -->
          </template>
		</v-data-table>

		<div class="text-center mt-5">
			<Pagination
				v-if="page_setting.is_show"
				:setting="page_setting"
			/>
		</div>

        <v-dialog
            v-if="detail.is_show"
            v-model="detail.is_show"
            width="800"
            @click:outside="closeData"
        >

            <v-card>
                <v-card-title class="text-h5 grey lighten-2">
                    詳細資料
                </v-card-title>

                <v-card-text class="pt-6">

                    <div class="mb-3">
                        <div class="mb-0 pb-0 text-subtitle-2 black--text">顧客ID:</div>
                        <div v-if="detail.item.customer_id">
                            {{detail.item.customer_id}}
                        </div>
                        <div v-else>
                            無
                        </div>
                    </div>

                    <div class="mb-3">
                        <div class="mb-0 pb-0 text-subtitle-2 black--text">顧客姓名:</div>
                        <div class="d-flex" v-if="detail.item.customer_id">
                            <span
                                class="d-flex align-center"
                                style="cursor:pointer;color:#5087e6;"
                                @click="goToCustomer(detail.item)"
                            >
                                {{detail.item.customer_name ? detail.item.customer_name: '----'}}
                                <v-icon 
                                    color="primary"
                                    class="ml-2"
                                    small
                                >
                                    mdi-open-in-new
                                </v-icon>
                            </span>

                        </div>
                        <div v-else>
                            {{detail.item.customer_name}}
                        </div>
                    </div>

                    <div class="mb-3">
                        <div class="mb-0 pb-0 text-subtitle-2 black--text">顧客信箱:</div>
                        <div>
                            {{detail.item.customer_email}}
                        </div>
                    </div>

                    <div class="mb-3">
                        <div class="mb-0 pb-0 text-subtitle-2 black--text">發票號碼:</div>
                        <div>
                            {{detail.item.invoice_number}}
                        </div>
                    </div>



                    <div class="mb-3">
                        <div class="mb-0 pb-0 text-subtitle-2 black--text">消費金額:</div>
                        <div>
                            {{detail.item.total_price}}
                        </div>
                    </div>


                    <v-card>
                        <v-data-table
                            hide-default-footer
                            :headers="detail.headers"
                            :items="detail.items"
                            :items-per-page="detail.items.length"
                        >

                        </v-data-table>
                    </v-card>

                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        color="primary"
                        text
                        @click="closeData"
                    >
                        關閉
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

	</v-card>
</template>
<script>
import Pagination from '@/components/Utils/Pagination.vue'
import {
    // apiGetInvoiceList,
    apiGetInvoiceData,
    apiGetInvoiceCollectorPrivate,
	apiOutputInvoiceData
} from '@/api/urlview.js'

import {
    apiGetContainer
} from '@/api/optimize.js'

	export default {
		name: 'TimerList',
		components: {
			Pagination
		},
		data: function() {
			return {	
                detail: {
                    is_show: false,
                    item: null,
                    items: [],
                    headers: [
                        {
                            text: '商品名稱',
                            sortable: false,
                            value: 'name',
                        },
                        {
                            text: '數量',
                            sortable: false,
                            value: 'quantity',
                        },
                        {
                            text: '單價',
                            sortable: false,
                            value: 'per_price',
                        },
                    ]
                },
				search: '',	
				page_title: "發票資料",
				is_loading: false,	
				datas: [],
				headers: [      
					{
						text: '姓名',
						sortable: false,
						value: 'customer_name',
					},
					{
						text: '信箱',
						sortable: false,
						value: 'customer_email',
					},
					{
						text: '發票號碼',
						sortable: false,
						value: 'invoice_number',
					},
					{
						text: '消費金額',
						sortable: false,
						value: 'total_price',
					},
					{
						text: '是否發送CAPI',
						sortable:false,
						value: 'fbtrace_id',
					},
					{ 
						text: '', 
						sortable: false,
						value: 'actions',
						align: 'right',
					}, 					             
				],
				page_setting: {
					is_show: false,
					selected_page: 1,
					total_page: 10,
					total_visible: 5,
				},
				selected_per_page: {
					name: "48筆",
					value: 48, 
				},
				per_page_items: [
					{
						name: "10筆",
						value: 10, 
					},
					{
						name: "24筆",
						value: 24, 
					},
					{
						name: "48筆",
						value: 48, 
					},
					{
						name: "100筆",
						value: 100, 
					},
				],
                backend_prefix: '',
			}
		},
		mounted: async function() {
			console.log("TimerList");
			this.initData()
		},
		methods: {
			initData: async function(){
				// 先抓網址上的頁碼，沒有預設就帶1
				let page_idx = parseInt(this.$route.query.page) ? parseInt(this.$route.query.page) : 1
				let limit = parseInt(this.$route.query.limit) ? parseInt(this.$route.query.limit) : this.selected_per_page.value
                let keyword = this.$route.query.keyword ? this.$route.query.keyword : ''
				this.search = keyword
				console.log('page_idx', page_idx)
				console.log('limit', limit)
                console.log('keyword', keyword)
				if (isNaN(limit)) {
					limit = 10
				}

				if (isNaN(page_idx)) {
					page_idx = 1
				}
                let data = null

                try {
                    let result = await apiGetInvoiceData(
                        this.$route.params.org_id, this.$route.params.id,
                        page_idx, limit
                    )
                    data = result
                    console.log('result', result)
                } catch (error) {
                    console.log('error',error)
					this.$root.vtoast.show({
						message: `取得資料失敗，原因: ${error}`,
					})
                }
				console.log('回應', data)
				if (data === null) {
					return
				}

				this.page_setting = {
					is_show: true,
					selected_page: page_idx,
					total_page: data.data.invoice_datas.totalPages,
				}
				this.datas = data.data.invoice_datas.content
                
                console.log('datas',this.datas)

                try {
                    let result = await apiGetInvoiceCollectorPrivate(
                        this.$route.params.org_id, this.$route.params.id
                    )
                    console.log('result', result)
                    this.page_title = result.data.invoice_collector.ict_name
                    // let column = JSON.parse(result.data.add_column)
                    // 設定麵包屑顯示選擇的人！
                    this.$store.commit('update_breadcrumbs',[
                        {
                            "text": "頁面優化",
                            disabled: true,
                        },
                        {
                            "text": "發票蒐集器",
                            disabled: false,
                            href: `/${this.$route.params.org_id}/${this.$route.params.container_id}/optimize_page/invoice_collector/`
                        },
                        {
                            "text": this.page_title ,
                            disabled: false,
                            href: `/${this.$route.params.org_id}/${this.$route.params.container_id}/optimize_page/invoice_collector/${this.$route.params.id}`
                        },
                        {
                            "text": '發票資料',
                        }
                    ])

                } catch (error) {
                    console.log('error',error)
					this.$root.vtoast.show({
						message: `取得設定失敗，原因: ${error}`,
					})
                }

                try {
                    let result = await apiGetContainer(
                        this.$route.params.org_id, this.$route.params.container_id
                    )
                    let add_column = result.data.add_column
                    if (add_column) {
                        add_column = JSON.parse(add_column)
                        if (add_column.else && add_column.else.else && add_column.else.else.backend_prefix) {
                            this.backend_prefix = add_column.else.else.backend_prefix.value
                        }
                    }
                } catch (error) {
                    console.log('error',error)
                }


			},
			// getSettings: async function(page_idx, limit){
			// 	let data = null
			// 	let that = this
			// 	data = await apiGetSettings(
			// 		page_idx, limit, 
			// 		this.$route.params.container_id, this.$route.params.org_id
			// 	).then(function(resp){
			// 		console.log(resp.data.data)
			// 		return resp.data.data

			// 	}).catch(function(error){
			// 		if (error.includes('401') || error.includes('403')) {
			// 			that.$root.vtoast.show({ 
			// 				message: `無權限使用此功能，原因: ${error}`
			// 			})
			// 			that.$router.push(`/${that.$route.params.org_id}/401`) 
			// 		}
			// 		else {
			// 			that.$root.vtoast.show({ 
			// 				message: `取得設定檔失敗，原因: ${error}`
			// 			}) 
			// 		}
					
			// 		return null
			// 	})
			// 	return data
			// },
			newSetting: function(){
				this.$router.push('new')
			},
			edit: function(item){
                console.log(item.id)
                let path = `/${this.$route.params.org_id}/${this.$route.params.container_id}/optimize_page/invoice_collector/${item.id}`
				this.$router.push(path)
			},
			viewData: function(item){
				console.log(item)
                if (item.items) {
                    let items = JSON.parse(item.items)
                    this.detail.items = items
                }
                this.detail.item = item
                this.detail.is_show = true
				// let path = `/${this.$route.params.org_id}/${this.$route.params.container_id}/optimize_page/invoice_collector/${item.id}/data`
				// this.$router.push(path)
			},
            closeData() {
                this.detail.item = null
                this.detail.items = []
                this.detail.is_show = false
            },
            goToCustomer(item){
                console.log(item)
                console.log(this.backend_prefix)
                if (!this.backend_prefix) {
                    alert('尚未設定電商後台網址路徑，請先前往容器進行設定。')
                    return
                }
                let path = ''
                if (this.backend_prefix.includes('shoplineapp')) {
                    path = `${this.backend_prefix}/users/${item.customer_id}`
                }
                else if(this.backend_prefix.includes('cyberbiz')){
                    path = `${this.backend_prefix}/admin/customers/${item.customer_id}`
                }
                else if(this.backend_prefix.includes('store.91app.com')){
                    path = `${this.backend_prefix}/${item.customer_id}`
                }

                console.log('path',path)
                window.open(path).focus()
            },
			// del: async function(item){
			// 	let that = this
			// 	let confirm_dialog = confirm(`確定要刪除 ${item.name} 嗎？`)
			// 	if (!confirm_dialog) {
			// 		return
			// 	}
			// 	apiDeleteSetting(item.id, this.$route.params.org_id).then(function(resp){
			// 		console.log(resp)
			// 		that.$root.vtoast.show({
			// 			message: `${item.name} 刪除成功`
			// 		})
			// 		that.initData()
			// 	}).catch(function(error){
			// 		console.log(error)
			// 		let msg = `${item.name} 刪除失敗，原因: ` + ( error.response ? error.response : error )
			// 		that.$root.vtoast.show({
			// 			message: msg
			// 		}) 
			// 	})
			// },
			chagePerPage: async function(selected_per_page){
				let query = this.$route.query;
				let tmp_query = {...query, limit: selected_per_page.value, page: 1};
				console.log(tmp_query)
				try {
					await this.$router.push({ path: this.$route.path, query: tmp_query})
				} catch (err) {
					if (err.name !== 'NavigationDuplicated') {
						throw err;
					}
				}
				await this.initData()
			},
			async exportReport(){
				try {
					let params = {
  						"invoice_collector_id": this.$route.params.id
					}
					let result = await apiOutputInvoiceData(
						this.$route.params.org_id, params
					)
					console.log('result', result)
					this.$root.vtoast.show({ 
						message: `匯出資料資料成功，請至 "資料匯出" > "作業進度" 下載檔案！`,
						timeout: 30000,
						color: 'primary' 
					}) 
				} catch (error) {
					console.log('error', error)
					if (error.includes('401') || error.includes('403')) {
						this.$root.vtoast.show({ 
							message: `你沒有權限執行此操作`
						}) 
					}
					else {
						this.$root.vtoast.show({ 
							message: `匯出資料失敗，原因: ${error}`
						}) 
					}
				}
			}
		},	
		computed: {
		}     
	}
</script>
<style scoped>
</style>